import { render, staticRenderFns } from "./JobSummaryReport.vue?vue&type=template&id=36bdd376&"
import script from "./JobSummaryReport.vue?vue&type=script&lang=js&"
export * from "./JobSummaryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports